import React from 'react';
// import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import ReportIcon from '@material-ui/icons/Report';
import {
  TextField,
  FormControl,
  InputAdornment,
  makeStyles,
} from '@material-ui/core';
// @material-ui/icons

import Button from 'components/MaterialKit/CustomButtons/Button.js';
import { CheckFormikValues } from '../../../../components/Formik/CheckFormikValues';

import styles from 'assets/jss/material-kit-react/views/loginPage.js';
// import { useSelector, shallowEqual } from 'react-redux';

const useStyles = makeStyles(styles);
const ReportPostForm = (props) => {
  const check = false;

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
  } = props;

  const classes = useStyles();
  return (
    <div style={{ dia: 'flex', justifyContent: 'center' }}>
      <form onSubmit={handleSubmit} className={classes.form}>
        <FormControl style={{ padding: '1rem', width: '100%' }}>
          <TextField
            fullWidth
            variant='outlined'
            label='Report'
            placeholder='Enter text....'
            name='text'
            value={values.text}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.text && touched.text}
            helperText={errors.text && touched.text && errors.text}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <ReportIcon />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>

        <div style={{ padding: '1rem' }}>
          <Button fullWidth round type='submit' color='warning' size='lg'>
            Submit Report
          </Button>
        </div>

        {check ? <CheckFormikValues {...props} /> : ''}
      </form>
    </div>
  );
};

ReportPostForm.propTypes = {};

export default ReportPostForm;
